import { Button } from '@mui/material';
import { UseQueryResult } from '@tanstack/react-query';
import { useLanguage } from '../contexts/language';
import IotsHeaderLogo from './IotsHeaderLogo';

interface ErrorPageTemplateProps {
  errorText: string;
  description: string;
  refetch?: () => ReturnType<UseQueryResult['refetch']>;
}

const ErrorPageTemplate = ({
  errorText,
  description,
  refetch,
}: ErrorPageTemplateProps) => {
  const { t } = useLanguage();
  return (
    <div className="main-container p-8 bg-iots-gold-100">
      <header>
        <IotsHeaderLogo variant="color" />
      </header>
      <main>
        <div className="p-[32px] lg:p-[184px]">
          <div className="uppercase mb-4 font-medium">{t('content.error')}</div>
          <h1 className="text-7xl mb-8">{errorText}</h1>
          <div>{description}</div>
          {!!refetch && (
            <Button
              type="button"
              variant="contained"
              onClick={() => void refetch()}
            >
              Retry
            </Button>
          )}
        </div>
      </main>
    </div>
  );
};

export default ErrorPageTemplate;
